export default {
  "Details": "_Details_56xy2_1",
  "Summary": "_Summary_56xy2_8"
};import "ni:sha-256;bnwzzT18kePPkg6C2Vg5vxXXWdzsjqGMacL0eEPsTjQ";